import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=a935dcca&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=a935dcca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a935dcca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a935dcca')) {
      api.createRecord('a935dcca', component.options)
    } else {
      api.reload('a935dcca', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=a935dcca&scoped=true&", function () {
      api.rerender('a935dcca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8EuT8dgEfhFju/JS/teamMember.vue"
export default component.exports